const ja = {
	title: '決済リンク',
	create: '支払いチェーンを作成する',
	paymentLinkId: '決済リンクID',
	paymentLink_Id: '支払いチェーン ID',
	bookingName: '購入者名',
	bookingNameEmail: '顧客名 / メールアドレス',
	orderNo: '注文番号',
	amount: '金額',
	tradingamount: '取引金額',
	minAmount: '最小値',
	maxAmount: '最大値',
	createTime: '作成日時',
	paymentLinkStatus: '決済リンク状況',
	status: '決済状況',
	operate: '操作',
	search: '検索',
	reset: 'リセット',
	add: '新規追加',
	edit: '編集',
	delete: '削除',
	export: 'エクスポート',
	detail: '詳細',
	resend: '再送信',
	disable: '無効に設定されています',
	tipsTitle: 'ヒント',
	invalidTip: '支払いチェーンが無効な状態に設定されています',
	setInvalid: 'この支払いチェーンを無効にしてもよろしいですか?無効化後は復元されて有効になりません。',
	sendSuccess: '正常に送信されました',
	deleteSuccess: '正常に削除されました',
	notTepmTitle: '請求書テンプレートをまだ作成していません',
	notTepmTip: 'ペイメントチェーンを作成する前に、[テンプレート管理]機能で請求書テンプレートを作成してください。',
	toNewVersion: '新しいバージョンのページに戻る',
	toOldVersion: '以前のバージョンに戻る',
	createLink: {
		title: '新しい支払いチェーンを作成する',
		otherFee: '他に料金はありますか?',
		yes: 'はい',
		no: 'いいえ',
		otherFeeName: 'その他の料金名',
		createSuccess: '支払いチェーンが正常に作成されました。',
		tip: '支払者のメールアドレスが作成情報に入力されていない場合、支払いチェーン リンクは別途生成されます。',
		createTemplate: 'テンプレートの作成に移動'
	},
	brandList: {
		title: 'ブランド情報のメンテナンス',
		brandName: 'ブランド名',
		website: 'Webサイト',
		updateTime: '更新日時',
		add: 'ブランドを追加',
		logo: 'Logo',
		preview: 'プレビュー',
		brandWeb: 'ブランドサイト',
		contact: '連絡先',
		validTime: '支払いチェーンの有効期間',
		email: '電子メール通知テンプレート',
		edit: '編集',
		delete: '削除',
	  	deleteTip: 'このブランド情報を削除してもよろしいですか?',
		message: {
			addSuccess: 'ブランドが正常に追加されました。',
			editSuccess: 'ブランドが正常に変更されました。'
		}

	},
	paymentLinkDetail: {
		setInvalid: '無効に設定されています',
		resend: '再送信',
		validTime: '有効期間',
		hours: '期間',
		remaining: '残り',
		linkAddress: '支払いチェーンリンクのアドレス',
		userInfo: '顧客情報',
		name: '名前',
		phone: '電話番号',
		email: 'E-mail',
		en: '英語',
		lang: 'チェックアウト言語',
		country: '支払い国/地域',
		remarks: '備考',
		orderInfo: '請求情報',
		productInfo: '製品情報',
		editProductInfo: '製品情報の変更',
		affiliatedWebsite: '所属ウェブサイト',
		currency: '請求通貨',
		serviceDate: 'サービス日',
		city: '市区町村',
		total: '合計',
		totalAmount: '合計金額',
		brandInfo: 'ブランド情報',
		brandName: 'ブランド名',
		addProduct: '新規追加',
		addProductTip: 'お願いします',
		createPayLinkValidate: '製品情報が追加されていないため、支払いチェーンを作成できません~',
		previewPayLinkValidate: '製品情報が追加されていないため、請求書をプレビューできません ~',
		cancelTip: '基本情報が完全に入力されていないため、支払いチェーンを生成できません。キャンセルを確認しますか?',
		// 支付链标准化
		template: '請求書テンプレート',
		website: '関連ウェブサイト',
		prodName: '商品名',
		prodDesc: '製品説明',
		PassengerName: '乗客名',
		hotelName: 'ホテル名',
		days: '部屋の日数',
		roomsNumber: '部屋の数',
		price: '単価',
		count: '量',
		amount: '金額',
		rentType: 'リースの種類',
		address: '住所',
		apartmentNumber: '出品番号',
		rentTime: 'リース期間',
		carModel: 'レンタカー',
		destinationAddress: '宛先アドレス',
		mileage: '走行距離',
		carRentalUnitPrice: 'レンタカー本体価格',
		carRentCountry: '送迎都市',
		carTime: 'サービス日',
		travelCity: '観光都市',
		takeOffCity: '出発都市',
		travelCountry: '観光国',
		travelTime: 'トラベルサイクル',
		flightNumber: '便名',
		aircraftCabinType: 'キャビンクラス',
		takeOffTime: '飛行機の出発時間',
		arrivalTime: '飛行機の到着時間',
		reChargeType: 'リチャージタイプ',
		accountId: 'リチャージアカウントID',
		accountName: 'リチャージアカウント名',
		appName: 'ゲーム/アプリ名',
		time: '{hour}時間{minute}分',
		resendSuccess: '送信成功'
	},
	brandListDetail: {
		breadcrumbTitle: 'ブランド情報のメンテナンス',
		breadcrumbAddTitle: 'ブランドを追加',
		addTitle: 'ブランド情報を追加する',
		editTitle: 'ブランド情報を編集する',
		brandName: 'ブランド名',
		brandWebsite: 'ブランドURL',
		emailTopics: 'メールの件名',
		contact: '連絡先',
		sender: '差出人',
		logo: 'Logo',
		emailTemp: 'メールテンプレート',
		dynamicData: '動的データ',
		validTime: '支払いの有効期限',
		hours: '期間',
		tips: '168時間以内',
		editButton: '改訂',
		addButton: '新規追加',
		cancelButton: 'キャンセル',
		confirmButton: '確認する',
		emailTempTip: 'ここをクリックしてメールテンプレートの入力を開始してください...'
	},
	emailPreview: {
		title: 'ブランド情報のメンテナンス',
		preview: 'プレビュー'
	},
	payLinkRules: {
		template: '請求書テンプレートを選択してください',
		accId: '所属するウェブサイトを選択してください',
		currency: '通貨を選択してください',
		brandId: 'ブランド名を選択してください',
		name: 'ご予約される方のお名前をご記入ください',
		phone: '携帯電話番号を入力してください',
		email: 'メールアドレスをご記入ください',
		country: '国/地域を選択してください',
		otherFeeName: '他の料金名を入力してください',
		otherFeeAmount: '金額をご記入ください',
		required: '必須項目です'
	},
	brandRules: {
		brandName: 'ブランド名をご記入ください',
		website: 'ブランドウェブサイトにご記入ください',
		subject: 'メールの件名を入力してください',
		contact: '連絡先情報をご記入ください',
		logo: 'ロゴをアップロードしてください',
		emailTemplate: 'メールテンプレートに記入してください',
		validHours: '支払いの有効期限を入力してください',
		validHours168: '支払いの有効期間は 168 時間を超えることはできません',
		emailSender: '送信者を選択してください'
	},
	// 春秋航空定制
	springAirlines: {
		message: {
			title: '手荷物を預ける',
			userInfo: '個人情報',
			billingInfo: '注文アドレス',
			orderInfo: '注文の詳細',
			name: '名前',
			phone: '携帯電話',
			email: 'メールアドレス',
			country: '国/地域',
			city: '市区町村',
			zipCode: '郵便番号',
			state: 'ステータス',
			street: '詳しい住所',
			goodsName: '商品名',
			baggageFee: '手荷物検査料金',
			amount: '金額',
			submit: '提出して支払う'
		},
		rules: {
			name: 'お名前をご記入ください',
			phone: '携帯電話番号を入力してください',
			amount: '金額をご記入ください'
		},
		goodsName: '手荷物検査料金'
	},
	// 模版管理
	templateManage: {
		title: 'テンプレート管理',
		sector: '業界',
		templateName: 'テンプレート名',
		addTemplate: '新しいテンプレートを追加',
		updateTime: '更新日時',
		defaultTemplate: 'システム',
		deleteTip: 'テンプレート情報を削除しますか?',
		deleteSuccess: '正常に削除されました',
		message: {
			addSuccess: 'テンプレートが正常に追加されました！',
			editSuccess: 'テンプレートが正常に変更されました！'
		}
	},
	templateDetail: {
		editTitle: 'テンプレートの変更',
		addTitle: '新しいテンプレートを追加',
		detailTitle: 'システムテンプレートの詳細',
		tip: '請求書を送信するとき、システムの固定フィールド言語は英語です。カスタムフィールド名にはできるだけ英語を使用してください。',
		customerData: '顧客情報',
		productData: '製品情報',
		addField: 'フィールドの追加',
		options: 'オプション',
		editOptions: '編集オプション',
		addOptions: 'オプションの追加',
		addOptionsTip: '顧客にオプションを 1 つだけ選択できるようにする',
		editButton: '改訂',
		addButton: '作成する',
		cancelButton: 'キャンセル'
	},
	templateFields: {
		fieldName: 'フィールド名',
		labelName: 'タグ名',
		fieldType: 'タイプ',
		fieldRule: '必須/オプション',
		fieldRequired: '必須',
		fieldOptional: 'オプション',
		fieldText: '文章',
		fieldNumber: '番号',
		fieldSelect: '落ちる',
		fieldDate: '日付',
		fieldPercent: '割合'
	},
	templateRules: {
		sector: 'あなたの業界を選択してください',
		templateName: 'テンプレート名を入力してください',
		fieldName: 'フィールド名を入力してください',
		fieldType: 'フィールドタイプを選択してください',
		fieldRule: 'フィールド検証ルールを選択してください',
		optionsRule: 'カスタムオプションを追加してください',
		optionsValid: '保存する前に新しいオプションを入力してください'
	},
	map: {
		longTerm: '長期レンタル',
		shortTerm: '短期レンタル',
		firstClass: 'ファーストクラス',
		businessClass: 'ビジネスクラス',
		premiumEconomy: 'プレミアムエコノミークラス',
		economy: '普通のエコノミークラス',
		small: '小型車',
		medium: '中型車',
		large: '大型車',
		premium: '高級車',
		suvTruck: 'トラック',
		van: 'ボックストラック',
		convertible: 'コンバーチブル'
	},
	industryMap: {
		apartmentRent: '家の賃貸',
		eCommerce: '電子商取引',
		carRental: 'レンタカー',
		airline: '航空会社',
		tourism: '旅行',
		rentalInfo: 'レンタル情報',
		productInfo: '製品情報',
		flightInfo: 'フライト情報',
		serviceInfo: 'サービス情報',
		reCharge: '補充する',
		reChargeInfo: 'リチャージ情報',
		hotel: 'ホテル',
		hotelInfo: 'ホテル情報'
	},
	// 支付链优化 - 3
	payLink: {
		orderPreview: '請求書のプレビュー',
		preview: 'プレビュー',
		saveDraft: '下書きを保存',
		send: '提出する',
		selectWeb: 'ウェブサイトを選択',
		orderNo: '注文番号',
		theme: 'テーマ',
		modeName: 'スキーマ名',
		payerInfo: '支払者情報',
		name: '名前',
		phone: '電話番号',
		remark: '備考',
		notThemeTitle: 'まだトピックを作成していません',
		notThemeTip: 'ペイメントチェーンを作成する前に、[テーマ管理]機能でテーマを作成してください。',
		notThemeButton: 'トピックの作成に移動',
		notModeTitle: 'まだスキーマを作成していません',
		notModeTip: '[モード管理]機能でモードを作成した後、ペイメントチェーンを作成してください。',
		notModeButton: '作成モードに移動します'
	},
	modeManage: {
		title: 'モード設定',
		addMode: '新規作成',
		modeName: 'スキーマ名',
		isSendEmail: 'メール送信',
		effectiveTime: '有効期間',
		updateTime: '更新日時',
		deleteTip: 'モード情報の削除を確認します',
		deleteSuccess: '正常に削除されました'
	},
	addMode: {
		title: 'スキーマ管理',
		addMode: '新規作成',
		editMode: '編集モード',
		emailInfo: '電子メールメッセージ',
		isNeedEmail: 'メールサービスは必要ですか？',
		yes: 'はい',
		no: 'いいえ',
		tip: '支払いリンクを送信すると、請求書に記入された顧客の電子メール アドレスにも電子メールが送信されます。',
		insert: '動的データの挿入',
		clientName: '顧客名',
		orderInfo: '請求書の詳細',
		checkAmount: '請求金額',
		checkId: '請求書番号',
		expireTime: '有効期限',
		paymentLink: '支払いリンク',
		emailTitle: 'メールのタイトル',
		emailContent: 'メール内容',
		sender: '差出人',
		linkExpire: 'リンク有効期間',
		oneDay: '24時間',
		twoDays: '48時間',
		custom: 'カスタマイズ',
		create: '作成する',
		edit: '改訂',
		previewEmail: 'メッセージのプレビュー',
		cancel: 'キャンセル',
		required: 'このオプションは必須です',
		validHours168: '支払いの有効期間は 168 時間を超えることはできません',
		hours: '期間',
		hoursTips: '168時間以内',
		previewTip: 'まずはメール内容をご記入ください'
	},
	theme: {
		manage: 'テーマ管理',
		title: 'トピックス情報',
		editTheme: 'トピックを編集する',
		copyTheme: 'トピックをコピー',
		addTheme: 'テーマ追加',
		deleteTheme: 'トピックの削除',
		themeName: 'トピック名',
		brandName: 'ブランド名',
		brandLogo: 'ブランドロゴ',
		preview: 'プレビュー',
		fields: '請求書フィールド情報',
		sector: '取引種別',
		ifSetDefault: 'デフォルトのテーマとして設定しますか?',
		setDefault: 'デフォルトのテーマとして設定',
		yes: 'はい',
		no: 'いいえ',
		create: '作成する',
		edit: '改訂',
		cancel: 'キャンセル',
		// 主题列表
		default: 'デフォルト',
		updateOf: 'に更新されました',
		deleteTip: '削除を確認しますか?',
		emptyTip: 'まだデータがありません。トピックを追加してください'
	},
	totalFee: {
		amount: '小計',
		totalAmount: '合計'
	},
	paylinkStatus: {
		all: 'すべて',
		vaild: '有効',
		invalid: '無効化'
	},
	payStatus: {
		all: 'すべて',
		unpaid: '未払い',
		successful: '支払い成功',
		failed: '決済失敗',
		reviewing: '審査中'
	},
	button: {
		cancel: 'キャンセル',
		confirm: '確認する',
		save: '保存する'
	}
}
export default ja
